<template>
  <div>
    <el-card class="mt-3">
      <div slot="header" class="d-flex space-between">
        <h3 class="m-0">Reporte de Asistencia</h3>
      </div>
      <el-form label-position="top" label-width="100px" :model="filters">
        <el-row :gutter="10">
          <el-col :md="6">
            <el-form-item label="Compañía">
              <el-select v-model="filters.company_id"
                         :placeholder="(loadingCompanies) ? 'cargando...' : 'Seleccionar Empresa'"
                         style="width: 100%">
                <el-option
                  v-for="item in companies"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.description }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item label="Planillas">
              <el-select
                style="width: 100%"
                v-model="filters.payrolls"
                multiple
                filterable
                :placeholder="(loadingPayRolls) ? 'cargando...':'Seleccionar Planillas'">
                <el-option
                  v-for="item in payrolls"
                  :key="item.id"
                  :label="item.name + ' ' + item.type"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item label="Centro de Costos">
              <el-select
                style="width: 100%"
                v-model="filters.cost_centers"
                multiple
                filterable
                :placeholder="(loadingCostCenters) ? 'cargando...':'Seleccionar Centro de Costos'">
                <el-option
                  v-for="item in cost_centers"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="Rango de Fechas">
              <el-date-picker
                v-model="filters.range"
                type="daterange"
                align="left"
                unlink-panels
                range-separator="a"
                start-placeholder="Fecha de Inicio"
                end-placeholder="Fecha Final"
                :picker-options="pickerOptions2">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="mt-2">
          <el-col :md="24">
            <el-button type="primary" :disabled="!filters.range" @click="exportReport()" :loading="exporting" plain>
              Descargar Reporte
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
  import {baseApi} from '../../configs/urls'
  import {parseError} from '../../packages/Helpers'
  import * as moment from 'moment'
  import {saveAs} from 'file-saver'
  export default {
    data () {
      return {
        payrolls: [],
        loadingPayRolls: false,
        companies: [],
        loadingCompanies: false,
        employees: [],
        loadingEmployees: false,
        cost_centers: [],
        loadingCostCenters: false,
        checkin_statuses: [],
        filters: {
          payrolls: [],
          cost_centers: [],
          companies: [],
          company_id: null
        },
        exporting: false,
        pickerOptions2: {
          shortcuts: [
            {
              text: 'Ultima Semana',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Ultima 15 dias',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Mes Pasado',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                picker.$emit('pick', [start, end])
              }
            }
          ]
        }
      }
    },
    methods: {
      exportReport () {
        const dateFormat = 'YYYY-MM-DD'
        const data = {
          init_date: moment(this.filters.range[0]).format(dateFormat),
          end_date: moment(this.filters.range[1]).format(dateFormat)
        }

        if (this.filters.company_id) {
          data.company_id = this.filters.company_id
        }
        if (this.filters.payrolls && this.filters.payrolls.length > 0) {
          data.payrolls = this.filters.payrolls
        }
        if (this.filters.cost_centers && this.filters.cost_centers.length > 0) {
          data.cost_centers = this.filters.cost_centers
        }
        this.exporting = true
        this.$http.post(baseApi + '/checkins/report', data, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/octet-stream'})
              saveAs(blob, 'reporte_de_asistencia.xlsx')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      }
    },
    mounted () {
      this.loadingPayRolls = true
      this.$http.get(baseApi + '/payrolls')
        .then(
          (response) => {
            this.payrolls = response.body
            this.loadingPayRolls = false
          },
          (res) => {
            this.$message.error(parseError(res)[0])
            this.loadingPayRolls = false
          }
        )

      this.loadingCompanies = true
      this.$http.get(baseApi + '/companies')
        .then(
          (response) => {
            this.companies = response.body
            this.loadingCompanies = false
          },
          (res) => {
            this.$message.error(parseError(res)[0])
            this.loadingCompanies = false
          }
        )
      this.loadingCostCenters = true
      this.$http.get(baseApi + '/cost-centers')
        .then(
          (response) => {
            this.cost_centers = response.body
            this.loadingCostCenters = false
          },
          (res) => {
            this.$message.error(parseError(res)[0])
            this.loadingCostCenters = false
          }
        )
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/reports/CheckInReport.vue